import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { apiFetch } from '../lib/api'
import type { AppNotification } from '@fellowship/shared'

export interface NotificationsResult {
  notifications: AppNotification[]
  unreadCount: number
}

export function useNotifications() {
  return useQuery({
    queryKey: ['users', 'me', 'notifications'],
    queryFn: () => apiFetch<{ data: NotificationsResult }>('/users/me/notifications'),
    staleTime: 60 * 1000,
  })
}

export function useMarkAllRead() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => apiFetch('/users/me/notifications/read-all', { method: 'POST' }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['users', 'me', 'notifications'] })
    },
  })
}

export function useUpdateNotificationPreference() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (notifyNewEvents: boolean) =>
      apiFetch('/users/me', { method: 'PATCH', body: JSON.stringify({ notifyNewEvents }) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['users', 'me'] })
    },
  })
}
